import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserPrefsService } from '../../../services/user-prefs.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css'
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  sidebarCollapsed = false;

  constructor(
    private readonly userPrefs: UserPrefsService,
  ) { }

  ngOnInit(): void {
    const savedState = this.userPrefs.get<boolean>('sidebar', 'view', 'collapsed');
    this.sidebarCollapsed = savedState ?? false;
  }

  ngOnDestroy(): void { }

  /**
   * Toggle sidebar between expanded (240px) and collapsed (60px) states.
   * Persists the state to localStorage + backend via UserPrefsService.
   */
  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    this.userPrefs.set('sidebar', 'view', 'collapsed', this.sidebarCollapsed);
  }
}
